import omit from 'lodash.omit';
import { decodeLastSearchCookie } from '@seek/seek-refine-job-search';

export const LAST_SEARCH_UPDATED = 'LAST_SEARCH_UPDATED';
export const LAST_SEARCH_CLICKED = 'LAST_SEARCH_CLICKED';

const initialState = {
  query: null,
  where: ''
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LAST_SEARCH_UPDATED: {
      const { query, summary } = action.payload;
      const { where = '' } = query;

      return {
        ...state,
        query,
        where,
        summary
      };
    }

    default: {
      return state;
    }
  }
}

const ignoredParams = ['page', 'whereid', 'nation', 'location', 'area'];

export const getLastSearch = ({ cookies, locale }) => dispatch => {
  if (!cookies.main) {
    return null;
  }

  const decodedCookie = decodeLastSearchCookie(cookies.main, locale);

  if (!decodedCookie) {
    return null;
  }

  const { query, summary } = decodedCookie;
  const cleanedQuery = omit(query, ...ignoredParams);

  return dispatch({
    type: LAST_SEARCH_UPDATED,
    payload: {
      query: cleanedQuery,
      summary
    }
  });
};

export const lastSearchClicked = () => ({
  type: LAST_SEARCH_CLICKED,
  meta: { hotjar: 'Last Search Clicked' }
});



/** WEBPACK FOOTER **
 ** ./app/store/lastSearch/lastSearch.js
 **/